import React from 'react';
import { SegmentedControl } from '@md-design-system/SegmentedControl';
import { useI18n } from '@shared/i18n/useI18n';
import { DOCUMENTS_TABS_ORDER } from '../../constants';
import type { TDocumentsTabsProps } from '../../types';

export const DocumentsTabs = ({ activeTab, onTabChange }: TDocumentsTabsProps) => {
    const { t } = useI18n();
    const options = DOCUMENTS_TABS_ORDER.map(tab => ({ key: tab, label: t(`documents.tabs.${tab}`) }));

    return <SegmentedControl options={options} value={activeTab} onChange={onTabChange} />;
};
